import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ServiceItem } from '../../services.models';

@Component({
  selector: 'app-services-grid-section',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './services-grid-section.component.html',
  styleUrl: './services-grid-section.component.scss'
})
export class ServicesGridSectionComponent {
  @Input({ required: true }) services: ServiceItem[] = [];
}
